module.exports = __webpack_public_path__ + "img/background-balance-business-583846-HiRes.046e8250.jpg";